import { useSession } from '@/lib/SessionContext';

export function useAsaPersonality() {
  const { member } = useSession();

  if (!member) {
    return {
      personality: '',
      nickname: '',
      sapaan: '',
      gaya: 'default',
      isCustom: false,
      isFadli: false
    };
  }

  const rawPersonality = member.asa_personality || '';
  const nickname = member.asa_nickname || '';
  const gender = (member.gender || 'pria').toLowerCase();
  const isWanita = gender === 'wanita' || gender === 'p' || gender === 'perempuan' || gender === 'female';
  const isFadli = member.full_name?.toLowerCase().includes('fadli');
  
  const firstName = member.full_name ? member.full_name.trim().split(' ')[0] : 'User';
  const baseName = (nickname || firstName).trim();

  // Cek apakah baseName sudah memiliki prefix sapaan
  const alreadyHasPrefix = /^(pak|bapak|bu|ibu|mas|mba|mbak|kak|kakak)\s+/i.test(baseName);

  // Hitung usia, generasi, dan zodiak jika ada birth_date
  let age = null;
  let generation = '';
  let zodiac = '';

  if (member.birth_date) {
    const birthDate = new Date(member.birth_date);
    const today = new Date();
    age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    const year = birthDate.getFullYear();
    if (year >= 1946 && year <= 1964) generation = 'Baby Boomer';
    else if (year >= 1965 && year <= 1980) generation = 'Gen X';
    else if (year >= 1981 && year <= 1996) generation = 'Millennial (Gen Y)';
    else if (year >= 1997 && year <= 2012) generation = 'Gen Z';
    else if (year >= 2013) generation = 'Gen Alpha';

    const day = birthDate.getDate();
    const month = birthDate.getMonth() + 1; // 1-12
    if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) zodiac = 'Aries';
    else if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) zodiac = 'Taurus';
    else if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) zodiac = 'Gemini';
    else if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) zodiac = 'Cancer';
    else if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) zodiac = 'Leo';
    else if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) zodiac = 'Virgo';
    else if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) zodiac = 'Libra';
    else if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) zodiac = 'Scorpio';
    else if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) zodiac = 'Sagittarius';
    else if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) zodiac = 'Capricorn';
    else if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) zodiac = 'Aquarius';
    else if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) zodiac = 'Pisces';
  }

  const isOwnerOrDirector = member.role === 'owner' || member.role === 'direktur' || member.position?.toLowerCase().includes('direktur');
  const isLeader = ['kepala', 'admin', 'finance', 'supervisor'].includes(member.role) || (member.position || '').toLowerCase().includes('kepala');
  const isMuda = (age !== null && age <= 27) || generation === 'Gen Z' || generation === 'Gen Alpha';

  let prefix = '';
  if (!alreadyHasPrefix) {
    if (member.panggilan_prefix) {
      prefix = member.panggilan_prefix;
    } else if (isOwnerOrDirector) {
      prefix = isWanita ? 'Bu' : 'Pak';
    } else if (isLeader) {
      prefix = isWanita ? 'Bu' : 'Pak';
    } else if (isMuda) {
      prefix = 'Kak';
    } else {
      prefix = isWanita ? 'Mba' : 'Mas';
    }
  }

  const sapaan = alreadyHasPrefix ? baseName : (prefix ? `${prefix} ${baseName}` : baseName);

  // Determine conversation style based on personality string
  let gaya = 'default';
  const lowerPers = rawPersonality.toLowerCase();
  
  if (lowerPers.includes('santai') || lowerPers.includes('asik') || lowerPers.includes('receh') || lowerPers.includes('canda')) {
    gaya = 'santai';
  } else if (lowerPers.includes('kaku') || lowerPers.includes('tegas') || lowerPers.includes('formal') || lowerPers.includes('bossy')) {
    gaya = 'formal';
  }

  // Contextual hints for AI if used
  let contextualPersonality = rawPersonality;
  if (age !== null) {
    const aiHints = `[Konteks Karyawan - Umur: ${age} tahun, Generasi: ${generation}, Zodiak: ${zodiac}]`;
    contextualPersonality = contextualPersonality ? `${aiHints} ${contextualPersonality}` : aiHints;
  }

  return {
    personality: contextualPersonality,
    rawPersonality,
    nickname,
    sapaan,
    prefix,
    gaya,
    gender,
    age,
    generation,
    zodiac,
    isCustom: !!contextualPersonality,
    isFadli
  };
}
